import { useInfiniteQuery } from 'react-query';
import { superAdminKeys } from './superAdminKeys';
import { EXPRESS_API } from 'configs/api/expressApi';
import { CustomerListParams, IResponse } from './customersQuery';

const getAllCustomersForSuperAdmin = async (params: CustomerListParams) => {
  return (
    await EXPRESS_API.get(`superadmin/customers`, {
      params,
    })
  ).data as IResponse;
};

export const useInfiniteCustomersQuery = ({
  params,
  enabled,
}: {
  params: CustomerListParams;
  enabled: boolean;
}) => {
  return useInfiniteQuery(
    superAdminKeys.infiniteCustomers(params),
    () => getAllCustomersForSuperAdmin(params),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      enabled: enabled,
      keepPreviousData: true,
    }
  );
};
